function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.container = document.getElementById('Cart-Drawer');

      if ( ! this.container ) {
        return;
      }
      let _this = this,
          button = document.getElementById('cart-drawer-toggle'),
          quantities = this.container.querySelectorAll('.quantity input'),
          removes = this.container.querySelectorAll('.remove'),
          backdrop = document.querySelector('.cart-drawer-backdrop');


      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.container.classList.add('active');
        this.container.focus();
        setTimeout(() => {
          if ( this.container.querySelector('.product-recommendations--full') ) {
            this.container.querySelector('.product-recommendations--full').classList.add('active');
          }
        });
        dispatchCustomEvent('cart-drawer:open');
      });

      backdrop.addEventListener('click', (e) => {
        dispatchCustomEvent('cart-drawer:close');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.container.addEventListener('change', this.debouncedOnChange.bind(this));
      this.container.addEventListener('variant-change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
      this.updateFreeShipping();
    }
    onChange(event) {
      if ( event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      } else if (event.target.hasAttribute('data-variant-selector-el') && event.target.getAttribute('data-variant-selector-el') === 'select') {
        this.updateVariant(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.container.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.bao-header__cart-toggle'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      let notes_toggle = document.getElementById('order-note-toggle');

      if ( ! notes_toggle ) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateFreeShipping() {
      const free_shipping = this.container.querySelector('.free-shipping');

      if ( free_shipping ) {
        let amount_text = free_shipping.querySelector('.free-shipping--text span');
        let total = parseInt(free_shipping.dataset.cartTotal, 10);
        let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10) * (Shopify.currency.rate || 1));
        let percentage = 1;

        if (total < minimum) {
          percentage = total / minimum;

          if ( amount_text ) {
            let remaining = minimum - total,
                format = window.theme.settings.money_with_currency_format || "${{amount}}";
            amount_text.innerHTML = formatMoney(remaining, format);
          }
        }

        free_shipping.style.setProperty('--percentage', percentage);
      }
    }
    updateQuantity(line, quantity) {
      this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname == "/apps/advanced-wishlist" ? "/" : window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      if ( this.container.querySelector('.product-recommendations--full') ) {
        this.container.querySelector('.product-recommendations--full').classList.remove('active');
      }
      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));

        this.removeProductEvent();
        this.notesToggle();
        this.updateFreeShipping();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });

        if ( this.container.querySelector(`#CartDrawerItem-${line}`) ) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
    }

    updateVariant(index, variantId) {
      const item = this.container.querySelector(`#CartDrawerItem-${index}`);

      if (!item) {
        return;
      }
      const itemPosition = Array.from(item.parentElement.children)
        .filter((child) => child.id && child.id.startsWith('CartDrawerItem-'))
        .indexOf(item);

      item.classList.add('thb-loading');

      fetch(`${theme.routes.cart_url}.js`)
        .then((response) => response.json())
        .then((cart) => {
          const currentItem = cart.items[Number(index) - 1];
          if (!currentItem) {
            throw new Error('Cart item not found');
          }

          return fetch(theme.routes.cart_add_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: currentItem.quantity,
              properties: currentItem.properties,
              selling_plan: currentItem.selling_plan
            })
          }).then((response) => {
            if (!response.ok) {
              throw new Error('Unable to add selected variant');
            }

            return fetch(theme.routes.cart_change_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: currentItem.key,
                quantity: 0,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname == "/apps/advanced-wishlist" ? "/" : window.location.pathname
              })
            });
          });
        })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Unable to remove previous variant');
          }
          return response.json();
        })
        .then((cart) => {
          this.getSectionsToRender().forEach((section) => {
            const sectionElement = document.getElementById(section.id);

            if (sectionElement && cart.sections[section.section]) {
              const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
              elementToReplace.innerHTML = this.getSectionInnerHTML(cart.sections[section.section], section.selector);
            }
          });

          const updatedLine = cart.items.findIndex((cartItem) => String(cartItem.variant_id) === String(variantId)) + 1;

          const updatedItem = updatedLine > 0 && this.container.querySelector(`#CartDrawerItem-${updatedLine}`);
          if (updatedItem && itemPosition >= 0) {
            const parent = updatedItem.parentElement;
            updatedItem.remove();
            const rows = Array.from(parent.children).filter((child) => child.id && child.id.startsWith('CartDrawerItem-'));
            parent.insertBefore(updatedItem, rows[itemPosition] || null);
          }

          this.updateFreeShipping();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          const loadingItem = this.container.querySelector(`#CartDrawerItem-${index}`);

          if (loadingItem) {
            loadingItem.classList.remove('thb-loading');
          }
        });
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}
